/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateDeviceJoinTokenRequestBody,
  CreateDeviceJoinTokenRequestBody$Outbound,
  CreateDeviceJoinTokenRequestBody$outboundSchema,
} from "../components/createdevicejointokenrequestbody.js";

export type CreateWorkloadDeviceJoinTokenSecurityOption1 = {
  sessionHeaderGramSession: string;
};

export type CreateWorkloadDeviceJoinTokenSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateWorkloadDeviceJoinTokenSecurity = {
  option1?: CreateWorkloadDeviceJoinTokenSecurityOption1 | undefined;
  option2?: CreateWorkloadDeviceJoinTokenSecurityOption2 | undefined;
};

export type CreateWorkloadDeviceJoinTokenRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createDeviceJoinTokenRequestBody: CreateDeviceJoinTokenRequestBody;
};

/** @internal */
export type CreateWorkloadDeviceJoinTokenSecurityOption1$Outbound = {
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateWorkloadDeviceJoinTokenSecurityOption1$outboundSchema:
  z.ZodMiniType<
    CreateWorkloadDeviceJoinTokenSecurityOption1$Outbound,
    CreateWorkloadDeviceJoinTokenSecurityOption1
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function createWorkloadDeviceJoinTokenSecurityOption1ToJSON(
  createWorkloadDeviceJoinTokenSecurityOption1:
    CreateWorkloadDeviceJoinTokenSecurityOption1,
): string {
  return JSON.stringify(
    CreateWorkloadDeviceJoinTokenSecurityOption1$outboundSchema.parse(
      createWorkloadDeviceJoinTokenSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateWorkloadDeviceJoinTokenSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateWorkloadDeviceJoinTokenSecurityOption2$outboundSchema:
  z.ZodMiniType<
    CreateWorkloadDeviceJoinTokenSecurityOption2$Outbound,
    CreateWorkloadDeviceJoinTokenSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function createWorkloadDeviceJoinTokenSecurityOption2ToJSON(
  createWorkloadDeviceJoinTokenSecurityOption2:
    CreateWorkloadDeviceJoinTokenSecurityOption2,
): string {
  return JSON.stringify(
    CreateWorkloadDeviceJoinTokenSecurityOption2$outboundSchema.parse(
      createWorkloadDeviceJoinTokenSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateWorkloadDeviceJoinTokenSecurity$Outbound = {
  Option1?: CreateWorkloadDeviceJoinTokenSecurityOption1$Outbound | undefined;
  Option2?: CreateWorkloadDeviceJoinTokenSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateWorkloadDeviceJoinTokenSecurity$outboundSchema:
  z.ZodMiniType<
    CreateWorkloadDeviceJoinTokenSecurity$Outbound,
    CreateWorkloadDeviceJoinTokenSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(
        z.lazy(() =>
          CreateWorkloadDeviceJoinTokenSecurityOption1$outboundSchema
        ),
      ),
      option2: z.optional(
        z.lazy(() =>
          CreateWorkloadDeviceJoinTokenSecurityOption2$outboundSchema
        ),
      ),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function createWorkloadDeviceJoinTokenSecurityToJSON(
  createWorkloadDeviceJoinTokenSecurity: CreateWorkloadDeviceJoinTokenSecurity,
): string {
  return JSON.stringify(
    CreateWorkloadDeviceJoinTokenSecurity$outboundSchema.parse(
      createWorkloadDeviceJoinTokenSecurity,
    ),
  );
}

/** @internal */
export type CreateWorkloadDeviceJoinTokenRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateDeviceJoinTokenRequestBody: CreateDeviceJoinTokenRequestBody$Outbound;
};

/** @internal */
export const CreateWorkloadDeviceJoinTokenRequest$outboundSchema: z.ZodMiniType<
  CreateWorkloadDeviceJoinTokenRequest$Outbound,
  CreateWorkloadDeviceJoinTokenRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createDeviceJoinTokenRequestBody:
      CreateDeviceJoinTokenRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      createDeviceJoinTokenRequestBody: "CreateDeviceJoinTokenRequestBody",
    });
  }),
);

export function createWorkloadDeviceJoinTokenRequestToJSON(
  createWorkloadDeviceJoinTokenRequest: CreateWorkloadDeviceJoinTokenRequest,
): string {
  return JSON.stringify(
    CreateWorkloadDeviceJoinTokenRequest$outboundSchema.parse(
      createWorkloadDeviceJoinTokenRequest,
    ),
  );
}
